import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import OmdbContainer from "./components/OmdbContainer";
import "./style.css"

function App() {
  return <OmdbContainer />;
}

export default App;
